// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3yLEU","modalFooterButton":"ModalNotes_modalFooterButton__SsvTd"};